// 主页框架
import React from 'react'
import styles from './main-layout.module.scss'
import { TabBar } from 'antd-mobile'
import { useLocation } from 'react-router-dom'
import Icon from '@/components/icon/icon'

interface Props {
  children: React.ReactNode
}

const MainLayout: React.FC<Props> = props => {
  const location = useLocation()
  const { pathname } = location

  const setRouteActive = (value: string) => {
    // window.location.href = value
    window.location.replace(value)
  }

  const tabs = [
    {
      key: '/advertising',
      title: '首页',
      icon: <Icon type="home" />,
    },
    {
      key: '/borrow-money',
      title: '借钱',
      icon: <Icon type="borrow-money" />,
    },
    {
      key: '/my',
      title: '我的',
      icon: <Icon type="my" />,
    },
  ]
  return (
    <div className={styles.mainLayout}>
      {props.children}
      <footer className={styles.footer}>
        <TabBar activeKey={pathname} onChange={value => setRouteActive(value)}>
          {tabs.map(item => (
            <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
          ))}
        </TabBar>
      </footer>
    </div>
  )
}

export default MainLayout
